
<template>
   <div style="word-wrap: break-word;max-width:14rem">{{ data.code }}</div> 
</template>
<script>
export default {
      props: ["data", "index", "column"],
}
</script>